var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndoTtrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.816,
    height: 35.218,
    viewBox: "0 0 30.816 35.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undoTtrash",
    transform: "translate(-267.859 -533.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "trash",
    d: "M29.715,2.2H21.461L20.814.915A1.651,1.651,0,0,0,19.336,0H11.473A1.632,1.632,0,0,0,10,.915L9.355,2.2H1.1A1.1,1.1,0,0,0,0,3.3V5.5A1.1,1.1,0,0,0,1.1,6.6H29.715a1.1,1.1,0,0,0,1.1-1.1V3.3A1.1,1.1,0,0,0,29.715,2.2ZM3.659,32.123a3.3,3.3,0,0,0,3.295,3.1H23.862a3.3,3.3,0,0,0,3.295-3.095L28.615,8.8H2.2Z",
    transform: "translate(267.859 533.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-undo-2",
    d: "M14.967,2.787A9.5,9.5,0,0,0,1.687,2.632L0,.843V7.134H5.931L4.294,5.4a5.709,5.709,0,1,1,3.631,9.82v3.8A9.515,9.515,0,0,0,14.967,2.787Z",
    transform: "matrix(0.766, 0.643, -0.643, 0.766, 282.583, 543.018)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoTtrash);
export default __webpack_public_path__ + "static/media/undoTtrash.c8c3e02e9c2c3dec2a9330abf232a163.svg";
export { ForwardRef as ReactComponent };